"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(theme) {
  return {
    root: {
      backgroundColor: theme.background,
      padding: theme.padding,
      borderRadius: theme.borderRadius,
      display: 'inline-block',
      verticalAlign: 'top',
      '& .qr-colored': {
        backgroundColor: theme.pixelBackground
      }
    }
  };
}